import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { scroller } from 'react-scroll';
import { Logo, SmallButton, PaddedContainer } from './styles';

const logoHeight = 26;
const Container = styled(PaddedContainer)`
  display: flex;
  height: 70px;
  z-index: 200;
  position: sticky;
  align-items: center;
  justify-content: space-between;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  background-color: transparent !important;

  a.application-navbar-search,
  a.application-navbar-likes,
  a.application-navbar-account-link,
  .navbar-callout-toggle {
    color: ${props => (props.theme.light ? props.theme.bodyColor : 'white')};
  }
`;

const Left = styled.div`
  text-align: left;
  display: flex;


  > a:not(:first-child) {
    margin-left: 30px;
    line-height: ${logoHeight}px;
    color: ${props => (props.theme.light ? props.theme.bodyColor : 'white')};
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightBold};
    font-size: 14px;
    text-transform: uppercase;
  }
`;

const Right = styled.div`
  text-align: right;
`;

const LoginButton = styled.a`
  background-color: transparent;
  border: none;
  color: ${props => (props.theme.light ? 'black' : 'white')};
  font-size: 14px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
  padding: 10px 20px;

  &:hover {
    color: ${props => (props.theme.light ? 'black' : 'white')};
  }
`;

export default function Header() {
  const { logo, isUserSignedIn } = React.useContext(ThemeContext);

  const scrollToJoinFreeForm = () => scroller.scrollTo('join-free-form', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return (
    <Container className="application-navbar" role="banner">
      <Left>
        <a href={isUserSignedIn ? '/feeds/latest' : '/'}>
          <Logo src={logo} />
        </a>
        <a href="/company/home">home</a>
        <a href="/company/features">features</a>
        <a href="/company/solutions">solutions</a>
        <a href="/company/our_story">our story</a>
        <a href="https://careers.smartrecruiters.com/LivewireMarkets">careers</a>
      </Left>
      {!isUserSignedIn && (
        <Right>
          <SmallButton type="button" onClick={scrollToJoinFreeForm}>join free</SmallButton>
          <LoginButton href="/sign_in">log in</LoginButton>
        </Right>
      )}
    </Container>
  );
}
